$(document).on("click touchstart", "[data-see-more]", function () {
  $(this).removeAttr("data-see-more");
});
